module.exports = __webpack_public_path__ + "img/wtb-t.703f9300.png";